<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import "babel-polyfill";

  export default {
    name: 'App',
    metaInfo: {
      title: "INiOT Reporting",
    },
  }
</script>

<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
  }
  #app {
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;
    font-size: 15px;
    height: 100%;
    background: url('./../assets/img/welcome_background.jpg');
    background-size: cover;
  }
  h1 {
    font-size: 1.35em;
    font-weight: 400;
  }
  h2 {
    font-size: 1.2em;
    font-weight: 600;
  }
  h3 {
    font-size: 1em;
    font-weight: 600;
  }
  div.content {
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/app/App.vue